import React from 'react';
import { Link } from 'gatsby';
import './product.scss';

function Product(props: any) {
    const { product } = props || {};
    const { originalPriceTag, priceTag, images, id, nameCN, brandCN, brand, name, priceTagCN } = product.product || product?.searchProduct?.product || product || {};
    return (
        <Link className='product-item' to={`/product/${id}`}>
            <div className='product-img'>
                <img src={images?.[0]?.thumbnail?.url || images?.[0].full.url} alt={`商品${nameCN || name}图片`} />
            </div>
            <div className='product-info'>
                <div className='product-name'>{brandCN || brand} | {nameCN || name}</div>
                <div className='product-origin'>
                    {product.origin?.startsWith('[') ? product.origin : `[${product.origin}]`}{product.merchantName}
                </div>
                <div className='product-price'>
                    <div className={`product-price-cn ${originalPriceTag ? 'blue' : ''}`}>{priceTagCN}</div>
                    <div className='product-price-en'>{priceTag}</div>
                    {originalPriceTag && <div className='product-price-origin'>{originalPriceTag}</div>}
                </div>
                <div className='product-tag'>
                    {(product.activityOffs || []).concat(product.off || []).map((off: string) => {
                        return <div className='tag-item' key={off}>
                            <span>{off}</span>
                            <span className='product-tag-line'></span>
                        </div>
                    })}
                </div>
            </div>
        </Link>
    )
}

export default Product;